module.exports = __webpack_public_path__ + "img/welcome.15d324ca.png";